import styled from '@emotion/styled'
import type { FC } from 'react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import type { Lesson } from '@segment/api/routes/growthMasters/queries'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import Card from '../../components/Card'

const copy = {
  heading: `Recommended lessons`,
  buttonText: `Explore all sessions`,
}

interface RecommendedLessonsProps {
  lessons: Lesson[]
}
const RecommendedLessons: FC<RecommendedLessonsProps> = ({ lessons }) => {
  const pageConfig = usePageConfig()

  return (
    <SectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <StyledCopyTextHeading tag="h3" variant="h2">
            {copy.heading}
          </StyledCopyTextHeading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ColumnTrack
          overrides={{
            sm: 1,
            lg: 3,
          }}
        >
          {lessons.map((card, key) => (
            <Card gated={false} {...card} key={card.title + key} />
          ))}
        </ColumnTrack>
        <ButtonWrapper>
          <ButtonText href={getAbsoluteUrl(`/growth-masters/curriculum/`, pageConfig)} iconEnd={ChevronRightIcon}>
            {copy.buttonText}
          </ButtonText>
        </ButtonWrapper>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledCopyTextHeading = styled(CopyText.Heading)`
  max-width: 684px;
  margin: 0 auto;
`

const ButtonWrapper = styled.div`
  padding-top: 56px;
  text-align: center;
`

export default RecommendedLessons
